<template>
  <section class="section-services-content pt-5" :style="`background-color: var(--white)`">
    <div class="page-padding pt-5">
      <div class="container-large">
        <div class="padding-bottom padding-huge pb-1">
          <div class="w-layout-grid service-component-wrapper" style="grid-template-columns: 1fr 5rem 1fr">
            <div>
              <h1 class="heading-medium office-detail-title">
                {{ vars.titleText }}
              </h1>
            </div>
            <div id="w-node-_67e6759a-e0fe-7f50-6614-460154e4a2c7-89606db0" class="service-details-content">
              <div class="margin-top margin-small">
                <div class="max-width-full d-flex flex-column gap-5">
                  <div v-if="vars.addressText">
                    <span class="text-size-tiny text-weight-light office-detail__label">Address</span>
                    <p class="office-detail__value">{{ vars.addressText }}</p>
                  </div>

                  <div v-if="phones">
                    <span class="text-size-tiny text-weight-light office-detail__label">Phone</span>
                    <p v-for="(phone, index) in phones" :key="`phone-${index}`" class="office-detail__value tw-mb-2">
                      <a :href="`tel:${phone.number}`">{{ phone.number }}</a>
                    </p>
                  </div>

                  <div v-if="emails">
                    <span class="text-size-tiny text-weight-light office-detail__label">Email</span>
                    <p v-for="(item, index) in emails" :key="`email-${index}`" class="office-detail__value tw-mb-2">
                      <a :href="`mailto:${item.email}`">{{ item.email }}</a>
                    </p>
                  </div>

                  <div>
                    <span class="text-size-tiny text-weight-light office-detail__label">Follow us </span>
                    <div class="d-flex gap-3 mt-2">
                      <div v-if="vars.facebookUrl" class="social-media">
                        <a :href="vars.facebookUrl" target="_blank">
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M9.33317 9.0026H10.9998L11.6665 6.33594H9.33317V5.0026C9.33317 4.31594 9.33317 3.66927 10.6665 3.66927H11.6665V1.42927C11.4492 1.4006 10.6285 1.33594 9.76184 1.33594C7.95184 1.33594 6.6665 2.4406 6.6665 4.46927V6.33594H4.6665V9.0026H6.6665V14.6693H9.33317V9.0026Z"
                              fill="white"
                            />
                          </svg>
                        </a>
                      </div>
                      <div v-if="vars.instagramUrl" class="social-media">
                        <a :href="vars.instagramUrl">
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5.20016 1.33594H10.8002C12.9335 1.33594 14.6668 3.06927 14.6668 5.2026V10.8026C14.6668 11.8281 14.2594 12.8116 13.5343 13.5367C12.8092 14.2619 11.8257 14.6693 10.8002 14.6693H5.20016C3.06683 14.6693 1.3335 12.9359 1.3335 10.8026V5.2026C1.3335 4.1771 1.74088 3.1936 2.46602 2.46846C3.19116 1.74332 4.17466 1.33594 5.20016 1.33594ZM5.06683 2.66927C4.43031 2.66927 3.81986 2.92213 3.36977 3.37221C2.91969 3.8223 2.66683 4.43275 2.66683 5.06927V10.9359C2.66683 12.2626 3.74016 13.3359 5.06683 13.3359H10.9335C11.57 13.3359 12.1805 13.0831 12.6306 12.633C13.0806 12.1829 13.3335 11.5725 13.3335 10.9359V5.06927C13.3335 3.7426 12.2602 2.66927 10.9335 2.66927H5.06683ZM11.5002 3.66927C11.7212 3.66927 11.9331 3.75707 12.0894 3.91335C12.2457 4.06963 12.3335 4.28159 12.3335 4.5026C12.3335 4.72362 12.2457 4.93558 12.0894 5.09186C11.9331 5.24814 11.7212 5.33594 11.5002 5.33594C11.2791 5.33594 11.0672 5.24814 10.9109 5.09186C10.7546 4.93558 10.6668 4.72362 10.6668 4.5026C10.6668 4.28159 10.7546 4.06963 10.9109 3.91335C11.0672 3.75707 11.2791 3.66927 11.5002 3.66927ZM8.00016 4.66927C8.88422 4.66927 9.73206 5.02046 10.3572 5.64558C10.9823 6.2707 11.3335 7.11855 11.3335 8.0026C11.3335 8.88666 10.9823 9.7345 10.3572 10.3596C9.73206 10.9847 8.88422 11.3359 8.00016 11.3359C7.11611 11.3359 6.26826 10.9847 5.64314 10.3596C5.01802 9.7345 4.66683 8.88666 4.66683 8.0026C4.66683 7.11855 5.01802 6.2707 5.64314 5.64558C6.26826 5.02046 7.11611 4.66927 8.00016 4.66927ZM8.00016 6.0026C7.46973 6.0026 6.96102 6.21332 6.58595 6.58839C6.21088 6.96346 6.00016 7.47217 6.00016 8.0026C6.00016 8.53304 6.21088 9.04174 6.58595 9.41682C6.96102 9.79189 7.46973 10.0026 8.00016 10.0026C8.5306 10.0026 9.0393 9.79189 9.41438 9.41682C9.78945 9.04174 10.0002 8.53304 10.0002 8.0026C10.0002 7.47217 9.78945 6.96346 9.41438 6.58839C9.0393 6.21332 8.5306 6.0026 8.00016 6.0026Z"
                              fill="white"
                            />
                          </svg>
                        </a>
                      </div>
                      <div v-if="vars.linkedinUrl" class="social-media">
                        <a :href="vars.linkedinUrl">
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M4.62663 3.334C4.62645 3.68762 4.48581 4.02669 4.23563 4.27661C3.98546 4.52654 3.64625 4.66684 3.29263 4.66667C2.93901 4.66649 2.59994 4.52584 2.35001 4.27567C2.10009 4.0255 1.95978 3.68629 1.95996 3.33267C1.96014 2.97904 2.10078 2.63998 2.35096 2.39005C2.60113 2.14013 2.94034 1.99982 3.29396 2C3.64758 2.00018 3.98665 2.14082 4.23658 2.391C4.4865 2.64117 4.6268 2.98038 4.62663 3.334ZM4.66663 5.654H1.99996V14.0007H4.66663V5.654ZM8.87996 5.654H6.22663V14.0007H8.85329V9.62067C8.85329 7.18067 12.0333 6.954 12.0333 9.62067V14.0007H14.6666V8.714C14.6666 4.60067 9.95996 4.754 8.85329 6.774L8.87996 5.654Z"
                              fill="white"
                            />
                          </svg>
                        </a>
                      </div>
                      <div v-if="vars.youtubeUrl" class="social-media">
                        <a :href="vars.youtubeUrl">
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_1119_1673)">
                              <path
                                d="M8.00016 2.66406C8.57016 2.66406 9.15483 2.67873 9.7215 2.70273L10.3908 2.73473L11.0315 2.77273L11.6315 2.8134L12.1795 2.85606C12.7742 2.90158 13.3338 3.15536 13.7598 3.57276C14.1859 3.99015 14.4511 4.54442 14.5088 5.13806L14.5355 5.4214L14.5855 6.02806C14.6322 6.65673 14.6668 7.34206 14.6668 7.9974C14.6668 8.65273 14.6322 9.33806 14.5855 9.96673L14.5355 10.5734C14.5268 10.6707 14.5182 10.7647 14.5088 10.8567C14.4511 11.4505 14.1858 12.0048 13.7596 12.4222C13.3334 12.8396 12.7736 13.0934 12.1788 13.1387L11.6322 13.1807L11.0322 13.2221L10.3908 13.2601L9.7215 13.2921C9.14805 13.317 8.57415 13.3299 8.00016 13.3307C7.42618 13.3299 6.85227 13.317 6.27883 13.2921L5.6095 13.2601L4.96883 13.2221L4.36883 13.1807L3.82083 13.1387C3.22613 13.0932 2.66653 12.8394 2.24048 12.422C1.81443 12.0046 1.54921 11.4504 1.4915 10.8567L1.46483 10.5734L1.41483 9.96673C1.36385 9.31149 1.33673 8.65461 1.3335 7.9974C1.3335 7.34206 1.36816 6.65673 1.41483 6.02806L1.46483 5.4214C1.4735 5.32406 1.48216 5.23006 1.4915 5.13806C1.54919 4.54453 1.81431 3.99034 2.24022 3.57296C2.66614 3.15558 3.22558 2.90173 3.82016 2.85606L4.3675 2.8134L4.9675 2.77273L5.60883 2.73473L6.27816 2.70273C6.85183 2.67782 7.42596 2.66493 8.00016 2.66406ZM8.00016 3.9974C7.45016 3.9974 6.88416 4.01206 6.3335 4.03473L5.6815 4.06606L5.0555 4.10273L4.4675 4.14273L3.92883 4.18473C3.64572 4.20482 3.37886 4.32449 3.17556 4.52255C2.97226 4.7206 2.84564 4.98424 2.81816 5.26673C2.74016 6.07273 2.66683 7.07606 2.66683 7.9974C2.66683 8.91873 2.74016 9.92206 2.81816 10.7281C2.87483 11.3094 3.33616 11.7614 3.92883 11.8101L4.4675 11.8514L5.0555 11.8914L5.6815 11.9287L6.3335 11.9601C6.88416 11.9827 7.45016 11.9974 8.00016 11.9974C8.55016 11.9974 9.11616 11.9827 9.66683 11.9601L10.3188 11.9287L10.9448 11.8921L11.5328 11.8521L12.0715 11.8101C12.3546 11.79 12.6215 11.6703 12.8248 11.4722C13.0281 11.2742 13.1547 11.0106 13.1822 10.7281C13.2602 9.92206 13.3335 8.91873 13.3335 7.9974C13.3335 7.07606 13.2602 6.07273 13.1822 5.26673C13.1547 4.98424 13.0281 4.7206 12.8248 4.52255C12.6215 4.32449 12.3546 4.20482 12.0715 4.18473L11.5328 4.1434L10.9448 4.1034L10.3188 4.06606L9.66683 4.03473C9.11159 4.01084 8.55592 3.99839 8.00016 3.9974ZM6.66683 6.38073C6.66679 6.31557 6.68266 6.25139 6.71307 6.19376C6.74349 6.13614 6.78751 6.08682 6.84133 6.05009C6.89515 6.01335 6.95712 5.99032 7.02187 5.983C7.08661 5.97568 7.15217 5.98428 7.21283 6.00806L7.26683 6.03473L10.0668 7.65073C10.1226 7.6829 10.1698 7.72805 10.2043 7.78235C10.2389 7.83665 10.2599 7.8985 10.2654 7.96263C10.271 8.02676 10.261 8.09129 10.2363 8.15073C10.2116 8.21017 10.1729 8.26277 10.1235 8.30406L10.0668 8.34406L7.26683 9.96073C7.2104 9.9934 7.14685 10.0118 7.08169 10.0143C7.01654 10.0168 6.95176 10.0033 6.893 9.97505C6.83424 9.94679 6.78328 9.90459 6.74456 9.85213C6.70584 9.79967 6.68053 9.73854 6.67083 9.67406L6.66683 9.61406V6.38073Z"
                                fill="white"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_1119_1673">
                                <rect width="16" height="16" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
export default defineNuxtComponent({
  name: 'OfficeDetailTheme2',

  mixins: [ComponentMixin],

  computed: {
    phones(): any {
      return this.groupedVariables.phones;
    },
    emails(): any {
      return this.groupedVariables.emails;
    },
  },

  data() {
    return {};
  },
});
</script>

<style scoped>
.office-detail__label {
  font-weight: 300;
  color: var(--brown--secondary);
  font-size: 0.8rem;
  line-height: 14.35px;
  letter-spacing: 5px;
  text-transform: uppercase;
}
.office-detail__value {
  font-weight: 300;
  color: var(--dark-brown);
  font-size: 1.3rem;
  padding-right: 4rem;
}
.w-min-content {
  width: min-content;
}
.service-details-content {
  align-self: start !important;
}

.office-detail-title {
  width: w-min-content;
  font-size: 5rem;
}

.social-media {
  background: var(--dark-brown);
  width: 36px;
  height: 36px;
  flex-shrink: 1;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--white);
}

@media screen and (max-width: 1024px) {
  .office-detail-title {
    font-size: 4rem;
  }
}

@media screen and (max-width: 768px) {
  .office-detail-title {
    width: max-content;
    font-size: 2rem;
  }
  .office-detail__value {
    font-size: 1.1rem;
  }
}
</style>
